import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DespesaReceitaService } from 'src/app/services/despesa-receita.service';
import { PessoaService } from 'src/app/services/pessoa.service';
import jsPDF from 'jspdf';
import 'jspdf-autotable';

@Component({
  selector: 'app-relatorio-page-credenciamento',
  templateUrl: './relatorio-page-credenciamento.component.html',
  styleUrls: ['./relatorio-page-credenciamento.component.css']
})
export class RelatorioPageCredenciamentoComponent implements OnInit {
  filteredClientes: any[] = [];
  formFiltro: FormGroup;
  dataSource: any[] = []

  pt = {
    firstDayOfWeek: 0,
    dayNames: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
    dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
    dayNamesMin: ['Do', 'Se', 'Te', 'Qu', 'Qu', 'Se', 'Sa'],
    monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho',
      'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
    monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
    today: 'Hoje',
    clear: 'Limpar'
  };

  cols = [
    { field: 'nome', header: 'Nome' },
    { field: 'tipo', header: 'Tipo' },
    { field: 'telefone_principal', header: 'Telefone' },
    { field: 'celular_principal', header: 'Celular' },
    { field: 'documento', header: 'Documento' },
  ];

  constructor(
    private _pessoaService: PessoaService,
    private _despesaReceita: DespesaReceitaService,
    private _formBuilder: FormBuilder,
  ) { }

  ngOnInit(): void {
    this.formFiltro = this._formBuilder.group({
      medico: [null],
      clinica: [null],
    });
  }

  filterCliente(event) {
    this._pessoaService.autoCompleteClientes(event.query).subscribe((json) => {
      this.filteredClientes = json
    });
  }

  index() {
    const filtros = this.formFiltro.value;
    this.dataSource = [];
    this._pessoaService.getListarMedicosOuClinicasComDocumento(filtros).subscribe((json) => {
      json.map((item) => {
        const tipo = item.tipo == 'FISICA' ? 'Particular' : 'Empresarial';
        
        this.dataSource.push({
          id: item.id,
          nome: item.nome,
          tipo: tipo,
          celular_principal: this.formatarTelefoneComCodigoPais(item.celular_principal),
          telefone_principal: this.formatarTelefoneComCodigoPais(item.telefone_principal),
          documento: this.formatarDocumento(item.documento, item.tipo),
        });
      });
    });
  }

  private formatarTelefoneComCodigoPais(numero: string): string {
    if (!numero) return 'Campo vazio';
    
    const digits = numero.replace(/\D/g, '');
    
    if (digits.startsWith('55')) {
      const ddd = digits.substring(2, 4);
      const numeroPrincipal = digits.substring(4);
      
      if (numeroPrincipal.length === 9) {
        return `+55 (${ddd}) ${numeroPrincipal.substring(0, 5)}-${numeroPrincipal.substring(5)}`;
      }
      else if (numeroPrincipal.length === 8) {
        return `+55 (${ddd}) ${numeroPrincipal.substring(0, 4)}-${numeroPrincipal.substring(4)}`;
      }
    }
    
    return numero || 'Campo vazio';
  }

  private formatarDocumento(documento: string, tipo: string): string {
    if (!documento) return 'Campo vazio';
    
    const digits = documento.replace(/\D/g, '');
    
    if (tipo === 'FISICA') {
      if (digits.length === 11) {
        return `${digits.substring(0, 3)}.${digits.substring(3, 6)}.${digits.substring(6, 9)}-${digits.substring(9)}`;
      }
    } else {
      if (digits.length === 14) {
        return `${digits.substring(0, 2)}.${digits.substring(2, 5)}.${digits.substring(5, 8)}/${digits.substring(8, 12)}-${digits.substring(12)}`;
      }
    }
    
    return documento;
  }


  // exportPdf() {
  //   let data = this.dataSource
  //   let col = this.cols.map(col => ({ title: col.header, dataKey: col.field }));

  //   import("jspdf").then(jsPDF => {
  //     import("jspdf-autotable").then(x => {
  //       const doc = new jsPDF.default("landscape");


  //       (doc as any).autoTable(col, data, {
  //         startY: (doc as any).autoTable() + 70,

  //         margin: { horizontal: 10 },
  //         styles: { overflow: "linebreak" },
  //         bodyStyles: { valign: "top" },
  //         columnStyles: { email: { columnHeight: 2 } },
  //         theme: "striped",
  //         showHead: "everyPage",
  //         didDrawPage: function (data) {

  //           // Header
  //           doc.setFontSize(15);
  //           doc.setTextColor(40);
  //           doc.text('Especialistas', data.settings.margin.left, 10);

  //           //Footer
  //           var str = "Pagina " + (doc as any).internal.getNumberOfPages();

  //           doc.setFontSize(10);

  //           var pageSize = doc.internal.pageSize;
  //           var pageHeight = pageSize.height
  //             ? pageSize.height
  //             : pageSize.getHeight();
  //           doc.text(str, data.settings.margin.left, pageHeight - 10);
  //         }
  //       });


  //       doc.save('especialistas.pdf');

  //     })
  //   })
  // }

  exportPdf() {
    const doc = new jsPDF('p', 'pt');
    const currentDate = new Date().toLocaleDateString();

    doc.setFontSize(18);
    doc.text('Relatório de Profissionais', 40, 40);
    doc.setFontSize(11);
    doc.text(`Gerado em: ${currentDate}`, 40, 60);

    let y = 80;
    const marginLeft = 40;

    const promises = this.dataSource.map(item => {
      return this._pessoaService.getListarEspecialidades(item.id).toPromise().then(especialidades => {
        return { ...item, especialidades };
      });
    });

    Promise.all(promises).then(itemsComEspecialidades => {
      itemsComEspecialidades.forEach(item => {
        (doc as any).autoTable({
          startY: y,
          head: [['Nome', 'Tipo', 'Celular', 'Telefone', 'Documento']],
          body: [[
            item.nome,
            item.tipo,
            item.celular_principal,
            item.telefone_principal,
            item.documento
          ]],
          styles: { fontSize: 10 },
          margin: { left: marginLeft, right: 40 },
        });

        y = (doc as any).lastAutoTable.finalY + 10;

        if (item.especialidades.length > 0) {
          (doc as any).autoTable({
            startY: y,
            head: [['Especialidade', 'Valor (R$)']],
            body: item.especialidades.map(e => [e.especialidade, e.valor]),
            styles: { fontSize: 8 },
            margin: { left: marginLeft, right: 40 },
          });
          y = (doc as any).lastAutoTable.finalY + 10;
        } else {
          doc.text('Sem especialidades cadastradas.', marginLeft, y);
          y += 20;
        }

        doc.setDrawColor(180);
        doc.line(marginLeft, y, doc.internal.pageSize.getWidth() - marginLeft, y);
        y += 20;

        if (y > doc.internal.pageSize.getHeight() - 100) {
          doc.addPage();
          y = 40;
        }
      });

      doc.save(`profissionais_${new Date().getTime()}.pdf`);
    });
  }


  exportExcel() {
    let data = this.dataSource
    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(data);
      const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
      this.saveAsExcelFile(excelBuffer, 'Especialistas');
    });
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
    });
  }

}
